import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";
import {
  type LinkToCustomerCommand,
  type SignInResult,
  postAuthMigrateLinkToCustomer,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SignInResult) => void;
  onError?: (error: unknown) => void;
};

/**
 * Links the currently authenticated non-migrated User to an existing Identity
 * by authenticating against that Identity's credentials (typically a Customer account).
 */
export const useLinkToCustomerMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: LinkToCustomerCommand) => postAuthMigrateLinkToCustomer(data),
    ),
    onSuccess: (result: SignInResult) => {
      queryClient.invalidateQueries({ queryKey: userInfoKeys.all });
      onSuccess?.(result);
    },
    onError,
  });
};
